import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const SearchableDropdown = ({
  globalIndex,
  field,
  value,
  onChange,
  onSearch,
  dropdownData,
  placeholder = "",
  focusedCell,
  setFocusedCell,
  showDropdown,
  setShowDropdown,
  dropdownRef,
  setOffset,
  offset,
  search_input,
  hasMore,
  getData,
  createNewUrl,           // ✅ new prop for create URL
  createNewLabel = "+ Create New" // ✅ new prop for label
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;

    const handleScroll = () => {
      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        hasMore
      ) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getData(newOffset, search_input);
      }
    };

    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  // ✅ Prepare data list with optional "+ Create New"
  const finalDropdownData = createNewUrl
    ? [{ isNew: true, name: createNewLabel }, ...(dropdownData || [])]
    : dropdownData || [];

  return (
    <td
      className="p-0 d-flex justify-content-center"
      style={{
        position: "relative",
        border:
          focusedCell.rowIndex === globalIndex && focusedCell.field === field
            ? "0.3px solid #270b79"
            : "",
      }}
    >
      <input
        type="text"
        id={`${placeholder}`}
        className="form-control tableinput noborder"
        style={{ fontSize: "0.8rem", textAlign: "center" }}
        placeholder={placeholder}
        onFocus={() => {
          setTimeout(() => 
            {
              setShowDropdown({ rowIndex: globalIndex, field });
              setFocusedCell({ rowIndex: globalIndex, field });
            }, 200)
        }}
        onBlur={() => {
            setShowDropdown({ rowIndex: null, field: null })
            setFocusedCell({ rowIndex: null, field: null });
        }}
        onChange={(e) => {
          const text = e.target.value;
          setOffset?.(0);
          onSearch(text);
          onChange(text);
        }}
        value={value}
      />

      <div
        ref={dropdownRef}
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          maxHeight:
            showDropdown?.rowIndex === globalIndex && showDropdown?.field === field
              ? "200px"
              : "0",
          display:
            showDropdown?.rowIndex === globalIndex && showDropdown?.field === field
              ? ""
              : "none",
          overflowY: "auto",
          background: "white",
          border:
            showDropdown?.rowIndex === globalIndex && showDropdown?.field === field
              ? "1px solid #ccc"
              : "",
          zIndex: 10,
        }}
      >
        {finalDropdownData.length > 0 ? (
          finalDropdownData.map((item, idx) => (
            <div
              key={idx}
              className="text-start"
              onClick={() => {
                if (item.isNew && createNewUrl) {
                  navigate(createNewUrl);
                } else {
                  onChange(item.name);
                }
                setShowDropdown({ rowIndex: null, field: null });
              }}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                backgroundColor: item.isNew ? "#ff8d5c" : "",
                color: item.isNew ? "white" : "",
                fontWeight: item.isNew ? "bold" : "normal",
              }}
            >
              <p className="m-0">{item.name}</p>
            </div>
          ))
        ) : (
          <div style={{ padding: "8px", color: "#888" }}>No results</div>
        )}
      </div>
    </td>
  );
};

export default SearchableDropdown;
